import { isMobile } from './util'
(function () {
  var html = document.getElementsByTagName('html')[0]
  if (!isMobile()) {
    html.style.fontSize = 'initial'
    return
  }
  var iW = document.documentElement.clientWidth
  var scale = iW / 375 * 20
  html.style.fontSize = scale + 'px' // 动态设置html根节点的font-size，用于rem布局；
})(document, window)
